import React from 'react';
import { utcToPtDateString } from 'lib/date';
import { md2html } from 'lib/string';

/**
 * display version and release notes
 * @returns {React.Component} app details
 */
const Version = () => (
  <div className="p-5">
    <h1>Canvas UI Version Info</h1>
    <p className="d-flex flex-column">
      {process.env.NODE_ENV === 'production' && (
        <span>
          <strong>App Version: </strong>
          {__APP_VERSION__}
        </span>
      )}
      <span>
        <strong>Deploy environment: </strong>
        {process.env.NODE_ENV}
      </span>
      <span>
        <strong>Built at: </strong>
        {utcToPtDateString(__APP_BUILD_TIME__, 'YYYY-MM-DD HH:mm:ss z')}
      </span>
      <span>
        <strong>Branch: </strong>
        {__APP_BRANCH__}
      </span>
    </p>
    <h2>Release Notes:</h2>
    <div dangerouslySetInnerHTML={{ __html: md2html(__APP_CHANGES__) }} />
    <p>
      <a
        href="https://gitlab.nordstrom.com/cxa/digital-assembly/canvas-ui/blob/develop/CHANGELOG.md"
        rel="noopener noreferrer"
        target="_blank"
        title="Full Changelog"
      >
        Full Changelog
      </a>
    </p>
  </div>
);

export default Version;
